<template>
  <!--RW打印 -->
  <div>
    <div class="main" v-for="(datas, index) in printData" :key="index" :datas="index">
      <div class="content">
        <div class="top">
          <div class="title">
            <div class="logo">
              <img src="../../assets/img/user-img/rwLogo.png" alt="">
            </div>
            <div class="name">RW - TW</div>
          </div>
        </div>
        <!-- 条形码 -->
        <div class="middle">
          <div class="order">
            <span v-if="datas.order_box">{{ datas.order_box.order }}- {{
              datas.order_box.box_no }}</span>
          </div>
          <div class="express_no">{{ datas.express_no }}</div>
          <div class="tiaoxingma">
            <canvas :id="'express_no' + index" style="height:200px;margin: 40px 0;" />
          </div>
          <div class="MADE">MADE IN CHINA</div>
          <div class="no">
            CTNO. {{ datas.number_by_express_no }}/{{ datas.count_by_express_no }}
          </div>
          <div class="time">
            <div>

            </div>

            <span>{{ getDate() }}</span>
          </div>
        </div>
        <!-- 配送单号 -->
        <div class="porder">
          <!-- FBA授权 -->
          <p style="font-size: 35px;text-align: center;" v-if="datas.porder.is_fba">
            {{ datas.porder.importer.company }}
          </p>
          <div class="order">{{ datas.porder_sn }}- {{ datas.number }}</div>
          <p style="font-size: 35px;" v-if="datas.porder.split_from" class="order">原单号:{{ datas.porder.split_from }}</p>
          <p style="font-size: 35px;" v-if="datas.porder.from_porder_sn" class="order">原单号:{{
            datas.porder.from_porder_sn }}</p>
          <p class="name"> <img src="../../assets/img/user-img/rw.png" alt="">{{ datas.porder.user.realname }} </p>
        </div>
        <!-- 尾部 -->
        <div class="footer">
          <!-- <div class="order_box" v-if="datas.order_box">{{ datas.order_box.order_sn }}-{{
      datas.order_box.box_no }}
          </div> -->
          <div class="row">
            <div class="item">
              Weight: <span>{{ datas.weight }}</span> kg
            </div>
            <div class="item">
              担当：{{ datas.porder.y_admin.realname }}
            </div>
          </div>
          <div class="row">
            <div class="item">
              Size: <span>{{ datas.length }}x{{ datas.width }}x{{ datas.height }}</span>
            </div>
            <div class="item">
              配货：{{ datas.porder.p_admin.realname }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDate } from '@/utlis/date'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(
      {
        printData: (state) => state.porderDetail.printData, //要打印的数据
      }
    )
  },
  data() {
    return {
      getDate
    };
  },
  mounted() {
    this.printData.forEach((item, index) => {
      this.getJsBarcode("#express_no" + index, item.express_no);
      if (item.order_box) {
        let a = item.order_box.order_sn.split('-')[0]
        let b = item.order_box.order_sn.split('-')[1]
        item.order_box.order = a.substr(a.length - 6) + '-' + b
      }
    })
  },
  methods: {
    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,
        height: 240,
        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #fff;
  padding: 60px;
  box-sizing: border-box;
  color: #000000 !important;

  div {
    box-sizing: border-box;
  }

  .content {
    width: 1061px;
    height: 1652px;
    border: 8px solid #000000;

    .top {
      height: 150px;
      box-sizing: border-box;
      border-bottom: 8px solid #000000;

      .title {
        display: flex;
        height: 150px;
        text-align: center;
        font-size: 72px;
        font-weight: 600;

        margin: 0;

        img {
          height: 142px;
          padding: 0 100px 0 50px;
          border-right: 8px solid #000000;
        }

        .name {
          flex: 1;
          line-height: 142px;
        }

      }

      .top-title {
        width: 100%;
        text-align: center;
        font-size: 120px;
        line-height: 180px;
        font-weight: 600;
        color: #000000;
        margin: 45px 0;
      }
    }

    .middle {
      padding: 130px 60px 43px;
      border-bottom: 8px solid #000000;
      position: relative;

      .order {
        position: absolute;
        top: 20px;
        left: 0;
        width: 100%;
        text-align: center;
        font-size: 80px;
        height: 90px;
        font-weight: bold;
      }

      .express_no {
        font-size: 85px;
        font-weight: bold;
        text-align: center
      }

      .no {
        text-align: center;
        font-size: 65px;
        font-weight: bold;
      }

      .time {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        font-size: 40px;
      }



      .tiaoxingma {

        height: 280px !important;
        overflow: hidden;
        margin: 40px 0;

        img {
          height: 280px !important;
        }
      }

      .MADE {
        width: 560px;
        height: 80px;
        background: #000000;
        font-size: 50px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 96px;
        text-align: center;
        margin: 20px auto;
      }

      .name {
        font-size: 48px;
        font-weight: 400;
        color: #000000;

        span {
          &:nth-last-child(1) {
            float: right;
          }
        }
      }

      .order_box {
        font-size: 65px;
        margin-bottom: 20px;
      }
    }

    .porder {
      padding: 30px;
      border-bottom: 8px solid #000000;
      height: 250px;

      .order {
        font-size: 62px;
        font-weight: 400;
        color: #000000;

      }

      .name {
        font-size: 40px;
        font-weight: 400;
        color: #000000;


        img {
          vertical-align: middle;
          height: 38px;
          margin-right: 10px;
          transform: translate(0, -5px);
        }

      }

    }

    .footer {
      width: 100%;
      position: relative;
      padding: 40px 40px;

      .row {
        display: flex;
        margin-bottom: 50px;
        justify-content: space-between;
        font-size: 40px;

        span {
          font-weight: bold;
          font-size: 70px;
        }
      }
    }
  }
}
</style>
